import RequestManager from "./RequestManager";

const getUiPermissionsForDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: "/permission/domain/v1/" + domainId
    });
    return response;
};

const Permission = {
    getUiPermissionsForDomain
};

export default Permission;